import styled from 'styled-components';

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ isEnabled }) => (isEnabled ? 'pointer' : 'not-allowed')};
  opacity: ${({ isEnabled }) => (isEnabled ? 1 : 0.5)};
`;

export const ToggleSwitch = styled.div`
  position: relative;
  width: 44px;
  height: 24px;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.blueMain : theme.colors.grey003};
  border-radius: 12px;
  transition: background-color 0.3s ease;
`;

export const ToggleSlider = styled.div`
  position: absolute;
  top: 2px;
  left: ${({ isActive }) => (isActive ? '22px' : '2px')};
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 50%;
  transition: left 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
`;
